import Collapse from '@shared/components/Collapse.tsx';
import CollapseItem from '@shared/components/CollapseItem';
import Markup from '@shared/components/Markup.tsx';
import {
    AccommodationBookingInformationPageContentResponseModel,
    AccordionItemElementElementModel,
    AccordionItemElementElementModelContentType,
} from '@shared/integrations/umbraco-taf-delivery-api/models';

interface IAccommodationBookingsInformationPage {
    content: AccommodationBookingInformationPageContentResponseModel;
}

const AccommodationBookingsInformationPage = ({ content }: IAccommodationBookingsInformationPage) => {
    return (
        <>
            <h1 className='page-title'>{content.properties?.heading ?? content.name}</h1>
            <div className='slide-up-fade-in mb-4'>
                <div className='row'>
                    <div className='col-xl-8'>
                        {content.properties?.body && content.properties.body.markup ? <Markup content={content.properties.body.markup} /> : null}
                        {content?.properties?.faq && content.properties.faq.items && (
                            <div className='mb-4'>
                                <Collapse id='faq-accommodation'>
                                    {content.properties.faq.items.map((item: any, index: number) => {
                                        if (item.content?.contentType === AccordionItemElementElementModelContentType.accordionItemElement) {
                                            const content = item.content as AccordionItemElementElementModel;
                                            return (
                                                <CollapseItem
                                                    as='h3'
                                                    key={index}
                                                    id={index.toString()}
                                                    parentId='faq-accommodation'
                                                    title={content.properties?.heading}
                                                    body={content.properties?.body?.markup}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                                </Collapse>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default AccommodationBookingsInformationPage;
